import React, { PropsWithChildren } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { PipeActions } from '../redux-store/thunks/pipes.thunks';
import { DatasetActions } from '../redux-store/thunks/datasets.thunks';
import { SystemActions } from '../redux-store/thunks/systems.thunks';

import Page from '../components/page';
import { EntitiesTabs } from './EntitiesTabs.container';
import { EntitiesRefreshButton } from '../components/entities-refresh-button/EntitiesRefreshButton.view';
import SesamLink from '../components/common/Links/SesamLink';
import Button from '../components/common/Button/Button';
import PageHeader, { PageHeaderGroup, PageHeaderTitle } from '../components/page-header';

import type { RootState } from '../types/state.types';
import type { ShouldRenderRefreshButton } from '../types/common.types';
import { useLoadInternalPipes } from 'src/hooks/useLoadInternalPipes.hook';

export const PipesListPage: React.FC<
  PropsWithChildren<{
    shouldRenderRefreshButton: ShouldRenderRefreshButton;
    includeInternal: boolean;
    shouldLoadDatasets: boolean;
  }>
> = ({ children, shouldRenderRefreshButton, includeInternal, shouldLoadDatasets }) => {
  const dispatch = useDispatch();

  const subId = useSelector((state: RootState) => state.subscription.id);
  const subUrl = useSelector((state: RootState) => state.subscription.url);
  const token = useSelector((state: RootState) => state.subscription.token);

  const { loadInternalPipes } = useLoadInternalPipes(subUrl, token);

  const loadAll = (includeInternal?: boolean) => {
    if (includeInternal) {
      loadInternalPipes();
    } else {
      dispatch(PipeActions.loadAll(includeInternal));
    }

    dispatch(SystemActions.loadAll());
  };

  const loadDatasets = (loadInternal?: boolean) => {
    dispatch(DatasetActions.loadAll(loadInternal));
  };

  return (
    <Page>
      <PageHeader>
        <PageHeaderTitle>Pipes</PageHeaderTitle>
        <PageHeaderGroup>
          <EntitiesRefreshButton
            onClick={() => {
              loadAll(includeInternal);

              if (shouldLoadDatasets) {
                loadDatasets();
              }
            }}
            shouldRenderRefreshButton={shouldRenderRefreshButton}
          />
          <SesamLink to={`/subscription/${subId}/pipes/new`} buttonLink={true}>
            <Button theme="primary">New pipe</Button>
          </SesamLink>
        </PageHeaderGroup>
      </PageHeader>
      <EntitiesTabs subId={subId} entityType="pipes">
        {children}
      </EntitiesTabs>
    </Page>
  );
};
